var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM7.948 13.628V22.35H9.306V16.274L10.594 19.466H11.364L12.736 16.26V22.35H14.108V13.614H12.722L11.028 17.632L9.334 13.628H7.948ZM18.7974 19.186L18 16.498L17.1897 19.186H18.7974ZM16.8479 20.32L16.236 22.35H14.668L17.622 13.572H18.378L21.332 22.35H19.736L19.1338 20.32H16.8479ZM24.188 17.898L21.906 22.35H23.53L25.042 19.34L26.596 22.35H28.276L25.896 17.884L27.996 13.628H26.456L25.028 16.498L23.558 13.628H21.934L24.188 17.898ZM18 6L22.3301 2.25H13.6699L18 6ZM2.25 13.6699L6 18L2.25 22.3301V13.6699ZM30 18L33.75 13.6699V22.3301L30 18ZM22.3301 33.75L18 30L13.6699 33.75H22.3301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearance);
export default __webpack_public_path__ + "static/media/clearance.7604446f74b36e101cad44e352fc1c1e.svg";
export { ForwardRef as ReactComponent };